import React from 'react';
//import tooths from '../../login-image.svg'
import './style.css' ;
import users from '../../services/users/index';
//import logo from '../../smile.svg';
const images = require("../../images.json")
const logo = images.smile
const tooths = images["login-image"]

export default class LoginComponent extends React.Component {
    state = {
        userName: "",
        password: "",
        error: ""
    }

    onInputChange = (e) => {
        let {name, value} = e.target
        let newState = Object.assign({}, this.state)
        newState[name] = value;
        newState.error = "";
        this.setState(newState);
    }

    hasErrors = () => {
        if(!this.state.userName){
            this.setState({error: "Porfavor introduzca un nombre de usuario."})
            return true
        } else if(!this.state.password){
            this.setState({error: "Introduzca una contraseña porfavor."})
            return true
        }
        return false
    }

    submit = (e) => {
        e.preventDefault()

        if(!this.hasErrors()){
            if(!this.props.validation) {
                if(this.state.userName == "mreina" && this.state.password == "123456") {
                    this.props.login({
                        userName: "mreina",
                        pin: "1234",
                        role: "developer",
                        status: "activo"
                    })
                }
            }

            users.findOne({
                userName: this.state.userName,
                password: this.state.password
            }, (err, user) => {
                if(!user)
                    this.setState({error: "Usuario y/o contraseña incorrecto."})
                else if(user.role !== "admin" && user.status !== "activo")
                    this.setState({error: "Esta cuenta se encuentra inactiva."})
                else
                    this.props.login(user)
            })
        }
    }

    reload = () => {
        window.location.reload();
    }

    render() {
        return (
            <div className="Login container">
                <div className="login-position">
                    <div className="card">
                        <div className="card-image">
                            {/* <figure className="image">
                                <img alt="tooths" src={tooths} />
                            </figure> */}
                            <img alt="Logo" src={logo} />
                        </div>
                        <div className="card-content">
                            <form className="content" id="form" onSubmit={this.submit}>
                                <div className="login-title">
                                    <h4>Inicio de sesión</h4>
                                    <div className="line"></div>
                                </div>
                                <div className="login-form">
                                    {this.state.error ?
                                        <p className="error">{this.state.error}</p> :
                                        <p><br /></p>}
                                    <div className="field">
                                        <p className="control has-icons-left has-icons-right">
                                            <input onChange={this.onInputChange} name="userName"
                                                className="input" placeholder="Usuario"/>
                                            <span className="icon is-small is-left">
                                                <i className="fas fa-user"></i>
                                            </span>
                                        </p>
                                    </div>
                                    <div className="field">
                                        <p className="control has-icons-left has-icons-right">
                                            <input onChange={this.onInputChange} name="password"
                                                className="input" type="password"
                                                placeholder="Contraseña"/>
                                            <span className="icon is-small is-left">
                                                <i className="fas fa-lock"></i>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div className="submit-button">
                                    {!this.props.validation &&
                                    <button style={{marginRight: 10}} onClick={this.reload} className="button is-link">Volver a configuración inicial</button>}
                                    <button className="button is-primary" form="form" type="submit">Iniciar sesión</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/login/index.js